export default __webpack_public_path__ + "static/media/floorSliderSecond.76d54873.jpg";